/** @format */
import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { getProductSearchParams } from '@toucan/common/services/search/product/helpers';
import { ProductSearchParams } from '@toucan/common/services/search/product/types';

export const useProductSearchParams = (): ProductSearchParams => {
    const router = useRouter();

    return useMemo(() => getProductSearchParams(router.query), [router.query]);
};
